import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Port, Vessel, Carrier, PersonalInformation, Plan, LogService } from './';

declare const moment: any;

@Injectable()
export class AppContext {
  login: boolean = false;
  isLoggedIn: boolean = false;

  viewMenu: boolean = false;
  viewSearch: boolean = true;
  searchType: string = '';

  message: boolean = false;
  messageTitle: string = 'Title';
  messageContent: string = 'Body';

  arrivalMessage: boolean = false;
  arrivalTitle: string = 'Welcome to the new Linescape';
  arrivalContent: string = 'Please contact us with your thoughts and feedback.';

  year = moment().format('YYYY');

  registerMessage: boolean = false;
  registerTitle: string = 'Register';
  registerContent: string = 'You must register to use that content';

  upgradeMessage: boolean = false;
  upgradeTitle: string = 'Upgrade Account';
  upgradeContent: string = 'You must upgrade your account to have access to that feature';

  showPersonalInformation: boolean = false;

  isSubEnterprise: boolean = false;

  signUpPlan: string = '';
  signUpPlanBilling: string = '';

  email: string = localStorage.getItem('email') || '';
  accountType: string = localStorage.getItem('accountType') || '';
  billingInterval: string = localStorage.getItem('billingInterval') || '';
  maxSchedules: number = +localStorage.getItem('maxSchedules') || 0;
  customer: any = JSON.parse(localStorage.getItem('customer')) || null;
  isCustomer: boolean = localStorage.getItem('isCustomer') === 'true' ? true : false || false; // localStorage holds strings
  plan: Plan;
  personalInformation: PersonalInformation;

  routes = JSON.parse(localStorage.getItem('favoriteRoutes')) || new Array<any>();
  ports = JSON.parse(localStorage.getItem('favoritePorts')) || new Array<Port>();
  carriers = JSON.parse(localStorage.getItem('favoriteCarriers')) || new Array<any>();
  vessels = JSON.parse(localStorage.getItem('vessels')) || new Array<any>();
  country: any = JSON.parse(localStorage.getItem('country')) || { name: '', id: '' };

  EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

  constructor(private router: Router, private logger: LogService) {
    this.logger.log('app.context', 'constructor', 'hello');
  }

  toggleLogin() {
    this.login = !this.login;
  }

  toggleSearch(searchType: string = 'schedule') {
    if (this.viewSearch && this.searchType == searchType) {
      this.closeSearch();
    } else if (this.viewSearch && this.searchType != searchType) {
      this.searchType = searchType;
    } else {
      this.openSearch(searchType);
    }
  }

  closeSearch() {
    this.viewSearch = false;
    this.searchType = '';
  }

  openSearch(searchType: string) {
    this.viewSearch = true;
    this.searchType = searchType;
  }

  toggleMenu() {
    this.viewMenu = !this.viewMenu;
  }

  showMessage(title: string, body: string) {
    this.messageTitle = title;
    this.messageContent = body;
    this.message = true;
  }

  hideMessage() {
    this.message = false;
  }

  showRegister() {
    this.registerMessage = true;
  }

  showSavedRoutesExplanation() {
    this.showMessage('Saved Routes', 'This button allows you to quickly access your most commonly searched routes.  Click the "Save Route" button at the bottom of the schedule search results to add a route to this list.');
  }

  hideRegister() {
    this.registerMessage = false;
  }

  openArrivalMessage() {
    this.arrivalMessage = true;
  }

  hideArrivalMessage() {
    this.arrivalMessage = false;
  }

  showUpgrade() {
    this.upgradeMessage = true;
  }

  hideUpgrade() {
    this.upgradeMessage = false;
  }

  setLogin(truth: boolean) {
    this.isLoggedIn = truth;
    if (!this.isLoggedIn) {
      this.logout();
    } else {
      this.login = false;
    }
  }

  setEmail(email: string) {
    localStorage.setItem('email', email);
    this.email = email.toLowerCase();
  }

  setAccountType(accountType: string = 'Basic') {
    localStorage.setItem('accountType', accountType);
    this.accountType = accountType.indexOf('api') > -1 ? 'Professional' : accountType;
  }

  setPersonalInformation(information: PersonalInformation) {
    this.personalInformation = information;
  }

  setBillingInterval(billingInterval: string) {
    localStorage.setItem('billingInterval', billingInterval);
    this.billingInterval = billingInterval;
  }

  setMaxSchedules(maxSchedules: number) {
    localStorage.setItem('maxSchedules', maxSchedules.toString());
    this.maxSchedules = maxSchedules;
  }

  setPlan(plan: any) {
    this.plan = new Plan(plan);
  }

  setRoutes(routes: any) {
    if (routes !== null && routes !== undefined) {
      this.routes = routes;
      localStorage.setItem('favoriteRoutes', JSON.stringify(this.routes));
    }
  }

  toSort(a: any, b: any) {
    let one = a.name.toUpperCase();
    let two = b.name.toUpperCase();
    return (one < two) ? -1 : (one > two) ? 1 : 0;
  }

  setPort(port: Port) {
    let isUnique: boolean = true;

    for (let current = 0; current < this.ports.length; current++) {
      if (port.id === this.ports[current].id) {
        isUnique = false;
      }
    }

    // generally awful solution to duplicate issue
    if (isUnique) {
      this.ports.push(port);
    }

    localStorage.setItem('port' + port.id, JSON.stringify(port));
    localStorage.setItem('favoritePorts', JSON.stringify(this.ports));
    try {
      this.ports.sort(this.toSort);
    } catch (ex) {
      this.logger.log('app.context', 'setPort error', ex);
    }
  }

  setCarrier(carrier: Carrier) {
    let isUnique: boolean = true;

    for (let current = 0; current < this.carriers.length; current++) {
      if (carrier.id === this.carriers[current].id) {
        isUnique = false;
      }
    }

    if (isUnique) {
      this.carriers.push(carrier);
    }

    localStorage.setItem('carrier' + carrier.id, JSON.stringify(carrier));
    localStorage.setItem('favoriteCarriers', JSON.stringify(this.carriers));
    try {
      this.carriers.sort(this.toSort);
    } catch (ex) {
      this.logger.log('app.context', 'setCarrier error', ex);
    }
  }

  setVessel(vessel: Vessel) {
    let isUnique: boolean = true;

    for (let current = 0; current < this.vessels.length; current++) {
      if (vessel.id === this.vessels[current].id) {
        isUnique = false;
      }
    }

    if (isUnique) {
      this.vessels.push(vessel);
    }

    localStorage.setItem('vessel' + vessel.id, JSON.stringify(vessel));
    localStorage.setItem('favoriteVessels', JSON.stringify(this.vessels));

    try {
      this.vessels.sort(this.toSort);
    } catch (ex) {
      this.logger.log('app.context', 'setVessel error', ex);
    }
  }

  setCustomer(customer: any) {
    this.customer = customer;
    localStorage.setItem('customer', JSON.stringify(customer));
  }

  setIsCustomer(stripeId: string) {
    this.isCustomer = (stripeId !== undefined && stripeId !== null && stripeId !== '');
    localStorage.setItem('isCustomer', this.isCustomer.toString());
  }

  setCountry(country: any) {
    this.country = country;
    localStorage.setItem('country', JSON.stringify(country));
  }

  getPlanSideBarType(): string {
    if (this.accountType === '') {
      return 'register';
    } else if (this.accountType === 'Premium') {
      return 'upgrade';
    } else {
      return 'upsell';
    }
  }

  logout() {
    this.clear();
    let url = this.router.url;

    this.clearStorage();
    this.router.navigate(['/']).then(result => this.router.navigateByUrl(url));
  }

  clear() {
    this.routes = new Array<any>();
    this.ports = new Array<any>();
    this.carriers = new Array<any>();
    this.vessels = new Array<any>();

    this.billingInterval = '';
    this.accountType = '';
    this.isCustomer = false;
    this.email = '';
    this.maxSchedules = 0;
    this.plan = new Plan({});
  }

  clearStorage() {
    // localStorage.removeItem('billingInterval');
    // localStorage.removeItem('accountType');
    // localStorage.removeItem('email');
    // localStorage.removeItem('maxSchedules');
    // localStorage.removeItem('customer');
    // localStorage.removeItem('billingInterval');
    // localStorage.removeItem('favoriteCarriers');
    // localStorage.removeItem('favoritePorts');
    // localStorage.removeItem('favoriteRoutes');
    // localStorage.removeItem('favoriteVessels');
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/app.context.ts